module.exports = __webpack_public_path__ + "img/20.TascuigoAriadryLight.ef10ea2b.png";